/**
 * DashboardContext — shared filter/scope state that every widget in a
 * DashboardRenderer reads (module, site, time range, department, refresh).
 * Keeps widgets self-contained: they pull their own data using this context
 * rather than having props threaded through the renderer.
 */
import React, { createContext, useContext } from 'react';

const DEFAULT = {
  module: null,
  siteId: null,
  time: { preset: 'last_30_days' },
  departmentId: null,
  dimensions: {}, // { dimensionKey: [values] } multi-select filters
  fyStartMonth: 4,
  compare: false, // request previous-period comparison on range KPIs
  standard: 'osha', // frequency-rate reporting standard: 'osha' | 'india'
  visibleWidgetIds: [], // ids of widgets currently shown (for export-matches-dashboard)
  refreshMs: 0,
  // Page-local site focus, set by clicking a row in the site-comparison table.
  // `siteId` above already reflects it; these let a widget show WHICH site is
  // focused and clear it, without reaching for the global site switcher.
  focusSiteId: null,
  onFocusSite: null,
};

const DashboardContext = createContext(DEFAULT);

export function DashboardProvider({ value, children }) {
  return <DashboardContext.Provider value={{ ...DEFAULT, ...value }}>{children}</DashboardContext.Provider>;
}

export function useDashboard() {
  return useContext(DashboardContext);
}

export default DashboardContext;
